import { useCrmEnrichmentJobToggleMutation } from "app/pages/sales-intelligence/modules/crm-enrichment/query/mutations/useCrmEnrichmentJobToggleMutation";
import sfEnrichmentApiService from "../../services/api/sfEnrichmentApiService";
import { salesforceEnrichmentQueryKeys } from "../key-factory";

export default function useSfEnrichmentJobToggleMutation() {
    return useCrmEnrichmentJobToggleMutation({
        apiService: sfEnrichmentApiService,
        queryKeys: salesforceEnrichmentQueryKeys,
    });
}
